// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1cW3Z","addWidgetButton":"Header_addWidgetButton__1bcVn","dashboardTabs":"Header_dashboardTabs__b0LS0","active":"Header_active__FZohU"};